import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import useTokenStore from "store/tokenStore";

const useDeleteShippingAddress = (addressId) => {
	const { accessToken } = useTokenStore();
	const queryClient = useQueryClient();

	const destroy = async () => {
		const instance = await InitApi({ accessToken });
		const response = await instance.delete(`/shipping-addresses/${addressId}`);
		await queryClient.invalidateQueries("shipping-addresses");
		await queryClient.invalidateQueries("orders");
		return response?.data;
	};

	return useMutation(destroy, {
		onSuccess: () => {
			toast.success("Address deleted successfully");
		},
		onError: (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);
		},
	});
};

export default useDeleteShippingAddress;
